import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageServicesService {

  constructor() { }

  sessionStore(storageLable, storageValue) {
    sessionStorage.setItem(storageLable, storageValue);
  }

  localStore(storageLable, storageValue) {
    localStorage.setItem(storageLable, JSON.stringify(storageValue));
  }

  getSession(storageLable) {
    return sessionStorage.getItem(storageLable);
  }

  getLocal(storageLable) {
    return localStorage.getItem(storageLable);
  }

}
